import * as React from "react"
import Footer from "../footers/Footer"
import { Helmet } from "react-helmet"

import NavBarSignedIn from "../navbar/NavBarSignedIn"

const MyPageLayout2 = ({ children, props }) => {
  return (
    <div className="font-sans ">
      <Helmet title={props} />
      <NavBarSignedIn />
      <div className="h-full min-h-screen bg-gray-100">
        <div className="h-full min-h-full">
          <div className="bg-gray-100 pb-32">
            <header className="py-10">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl mob:text-center font-bold text-meny-700">
                  {props}
                </h1>
              </div>
            </header>
          </div>

          <main className="-mt-32">
            <div className="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
              <div className="bg-white rounded-lg shadow px-5 py-6 sm:px-6">
                <div className="sm:mx-8 sm:my-5">{children}</div>
              </div>
            </div>
          </main>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default MyPageLayout2
